module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og engelsk_sekundærlogo_pos(svart).682a3167.pdf";